module.exports = __webpack_public_path__ + "ag.no2.39d96200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ag.no2.jpg
// module id = u7nA
// module chunks = 0